// Resolve a view-column preference for a given country, falling back to the
// user's default view when there's no per-country override.
//   viewFor('merchantView', 'SG')      -> preferences.merchantViewByCountry.SG || preferences.merchantView
//   viewFor('caseTriggerView', country) -> ...caseTriggerViewByCountry[country] || caseTriggerView
export const viewFor = (key, country) => {
  let preferences = {};
  try {
    preferences = JSON.parse(localStorage.getItem("preferences")) || {};
  } catch (e) {
    preferences = {};
  }
  const byCountry = preferences[`${key}ByCountry`] || {};
  const override = country && byCountry[country];
  return override && override.length ? override : preferences[key] || [];
};
